/** 外部站点默认语言：与 nuxt.config.ts 的 i18n.defaultLocale 保持一致，URL 中不展示语言段。 */
const DEFAULT_EXTERNAL_LOCALE = 'en'

/**
 * 在外部站点路径中插入当前语言段，保证与当前站点语言保持一致。
 * @param path 目标站点内的相对路径，如 `/about`、`/terms/service`
 * @param locale 当前站点语言代码，如 `zh-cn`；默认语言 `en` 不插入语言段
 * @returns 带语言段的路径，如 `/zh-cn/about`；路径已带相同语言段时原样返回
 */
export const resolveExternalLocalePath = (path: string, locale: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const normalizedLocale = locale.trim().toLowerCase()
  if (!normalizedLocale || normalizedLocale === DEFAULT_EXTERNAL_LOCALE) {
    return normalizedPath
  }

  const localePrefix = `/${normalizedLocale}`
  if (normalizedPath === localePrefix || normalizedPath.startsWith(`${localePrefix}/`)) {
    return normalizedPath
  }

  return `${localePrefix}${normalizedPath}`
}

/**
 * 将绝对站点 origin 与语言化路径组合为可外跳的完整 URL。
 * @param origin 目标站点 origin，如 `https://www.wikibit.com`
 * @param localizedPath 目标站点内的相对路径，可已包含语言段
 * @param locale 当前站点语言代码；传入时按外部站点规则补齐语言段，默认语言 `en` 不展示
 * @returns 可外跳的完整 URL
 */
export const resolveExternalUrl = (origin: string, localizedPath: string, locale?: string) => {
  const normalizedOrigin = origin.trim().replace(/\/+$/u, '')
  const normalizedPath = resolveExternalLocalePath(localizedPath, locale ?? '')

  return new URL(normalizedPath, `${normalizedOrigin}/`).toString()
}
